module.exports = __webpack_public_path__ + "img/dashboard-expense.35b0ee6f.svg";